<div class="filter-containt responsive-filter-container">
    <div class="filter-item" *ngIf="['muckpiles'].includes(type$ | async)">
        <searchable-select 
            label="Muckpiles"
            [customWidth]="'width-large-selection'" 
            [valueKey]="'id'"
            [labelKey]="'name'"
            [options]="muckpiles$ | async"
            [value]="muckpileId$ | async"
            (valueChange)="handleMuckpileChnage($event)"
            [disabled]="(chartLines$ | async) === undefined">
        </searchable-select>
    </div>
    <!-- Site dropdown, visible only for ClientAdmin and Super Admin -->
    <div class="filter-item site-select" *ngIf="(user$ | async)?.permissions >= 2 && ['analytics', 'shift-analytics', 'details', 'video', 'ai-score', 'device-flow', 'trace'].includes(type$ | async)">
       <searchable-select
           label="Site"
           [customWidth]="'width-large-selection'" 
           [valueKey]="'id'"
           [labelKey]="'name'"
           [options]="sites$ | async"
           [value]="selectedSiteId$ | async"
           (valueChange)="selectedSiteId$.next(+$event)"
           [disabled]="(chartLines$ | async) === undefined">
       </searchable-select>
    </div>
    <div class="filter-item"
        *ngIf="['analytics', 'shift-analytics', 'details',  'video', 'ai-score'].includes(type$ | async)">
        <searchable-select 
            label="Device"
            [valueKey]="'uuid'" 
            [labelKey]="'name'" 
            [options]="devices$ | async"
            [value]="deviceUuid$ | async" 
            (valueChange)="deviceUuid$.next($event)"
            [disabled]="(chartLines$ | async) === undefined">
        </searchable-select>
    </div>
    <div class="filter-item" *ngIf="['analytics', 'shift-analytics', 'ai-score'].includes(type$ | async)">
        <searchable-select 
            label="Duration" 
            [customWidth]="'width-duration'" 
            [valueKey]="'key'" 
            [labelKey]="'label'"
            [options]="durationOptions | async" 
            [value]="duration$ | async" 
            (valueChange)="duration$.next($event)"
            [disabled]="(chartLines$ | async) === undefined">
        </searchable-select>
    </div>
    <div class="filter-item" *ngIf="['trace'].includes(type$ | async)">
        <searchable-select 
            label="Duration" 
            [valueKey]="'key'" 
            [labelKey]="'label'"
            [options]="vehicleQueryDurationOptions | async" 
            [value]="vehicleQueryDuration$ | async"
            [disabled]="(chartLines$ | async) === undefined" 
            (valueChange)="vehicleQueryDuration$.next($event)">
        </searchable-select>
    </div>
    <div class="filter-item" *ngIf="(duration$ | async) === 'week'">
        <ng-container *ngIf="(duration$ | async) === 'week'">
            <mat-form-field class="custom-width-mat-picker"
                *ngIf="['analytics', 'shift-analytics', 'ai-score'].includes(type$ | async)">
                <mat-label>Enter a date range</mat-label>
                <mat-date-range-input [rangePicker]="picker" [disabled]="(chartLines$ | async) === undefined">
                    <input matStartDate [value]="defaultDateRange?.start" placeholder="Start date">
                    <input matEndDate [value]="defaultDateRange?.end" placeholder="End date">
                </mat-date-range-input>
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-date-range-picker #picker></mat-date-range-picker>
            </mat-form-field>
        </ng-container>
    </div>
    <div class="filter-item" *ngIf="(duration$ | async) === 'shifts'">
        <ng-container>
            <mat-form-field class="custom-width-mat-picker"
                *ngIf="['analytics', 'shift-analytics', 'ai-score'].includes(type$ | async)">
                <mat-label> Shift </mat-label>
                <mat-select [disabled]="(chartLines$ | async) === undefined" [value]="shift$ | async"
                    (valueChange)="shift$.next($event)">
                    <mat-option *ngFor="let shift of shifts$ | async" [value]="shift">
                        {{ shift.title }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </ng-container>
    </div>

    <ng-container *ngIf="(duration$ | async) === 'custom'">
        <div class="filter-item">
            <mat-form-field class="custom-width-mat-picker width-small"
                *ngIf="['analytics', 'shift-analytics', 'ai-score'].includes(type$ | async)">
                <mat-label>Start Date</mat-label>
                <date-picker [value]="tempBegin" [disabled]="(chartLines$ | async) === undefined"
                    (valueChange)="tempBegin = $event">
                </date-picker>
            </mat-form-field>
        </div>
        <div class="filter-item">
            <mat-form-field class="custom-width-mat-picker width-small"
                *ngIf="['analytics', 'shift-analytics', 'ai-score'].includes(type$ | async)">
                <mat-label>Start Time</mat-label>
                <time-picker [value]="tempBegin" [disabled]="(chartLines$ | async) === undefined"
                    (valueChange)="tempBegin = $event">
                </time-picker>
            </mat-form-field>
        </div>
        <div class="filter-item">
            <mat-form-field class="custom-width-mat-picker width-small"
                *ngIf="['analytics', 'shift-analytics', 'ai-score'].includes(type$ | async)">
                <mat-label>End Date</mat-label>
                <date-picker [value]="tempEnd" [disabled]="(chartLines$ | async) === undefined"
                    (valueChange)="tempEnd = $event">
                </date-picker>
            </mat-form-field>
        </div>
        <div class="filter-item">
            <mat-form-field class="custom-width-mat-picker width-small"
                *ngIf="['analytics', 'shift-analytics', 'ai-score'].includes(type$ | async)">
                <mat-label>End Time</mat-label>
                <time-picker [value]="tempEnd" [disabled]="(chartLines$ | async) === undefined"
                    (valueChange)="tempEnd = $event">
                </time-picker>
            </mat-form-field>
        </div>
        <div class="filter-item">
            <button *ngIf="['analytics', 'shift-analytics', 'ai-score'].includes(type$ | async)" mat-flat-button
                color="primary" (click)="fetch()">
                Fetch
            </button>
        </div>
    </ng-container>
    <div class="filter-item"
        *ngIf="['analytics', 'shift-analytics', 'ai-score'].includes(type$ | async) && (duration$ | async) === 'shifts'">
        <mat-form-field class="custom-width-mat-picker">
            <mat-label>Select Date</mat-label>
            <date-picker [value]="customShiftDate$ | async" [disabled]="(chartLines$ | async) === undefined"
                (valueChange)="customShiftDate$.next($event)">
            </date-picker>
        </mat-form-field>
    </div>

    <ng-container>
        <div class="mat-button-toggles-primary filter-item" *ngIf="(type$ | async) === 'analytics'">
            <mat-button-toggle-group appearance="legacy" name="fontStyle" aria-label="Font Style" color="primary"
                class="type-content" [value]="weightType$ | async">
                <mat-button-toggle [value]="'area'" (click)="weightType$.next('area')" matTooltip="Quantity : Area"
                    [matTooltipPosition]="'below'"><mat-icon svgIcon="area" 
                        class="maticon header-toggle-icon"></mat-icon></mat-button-toggle>
                <mat-button-toggle [value]="'volume'" (click)="weightType$.next('volume')"
                    matTooltip="Quantity : Volume" [matTooltipPosition]="'below'"><mat-icon svgIcon="cube"
                        class="maticon header-toggle-icon"></mat-icon></mat-button-toggle>
            </mat-button-toggle-group>
        </div>

        <div class="mat-button-toggles-primary filter-item" *ngIf="(type$ | async) === 'analytics'">
            <mat-button-toggle-group appearance="legacy" name="fontStyle" aria-label="Font Style" color="primary"
                class="type-content" [value]="chartType$ | async" (valueChange)="chartType$.next($event)">
                <mat-button-toggle [value]="'line'" matTooltip="ChartType : Line"
                    [matTooltipPosition]="'below'"><mat-icon class="maticon header-toggle-icon">timeline</mat-icon></mat-button-toggle>
                <mat-button-toggle [value]="'series'" matTooltip="ChartType : Column"
                    [matTooltipPosition]="'below'"><mat-icon class="maticon header-toggle-icon">equalizer</mat-icon></mat-button-toggle>
            </mat-button-toggle-group>
        </div>
    </ng-container>

    <ng-container>
        <div class="mat-button-toggles-primary filter-item" *ngIf="(type$ | async) === 'muckpiles'">
            <mat-button-toggle-group appearance="legacy" name="fontStyle" aria-label="Font Style" color="primary"
                class="graph-opt" [value]="graph$ | async">
                <mat-button-toggle class="graph-toggle" [value]="'imported'"
                    (click)="graph$.next('imported')">Imported</mat-button-toggle>
                <mat-button-toggle class="graph-toggle" [value]="'tagged'"
                    (click)="graph$.next('tagged')">Tagged</mat-button-toggle>
                <mat-button-toggle class="graph-toggle" [value]="'comparison for both'"
                    (click)="graph$.next('comparison for both')">Comparison for both</mat-button-toggle>
            </mat-button-toggle-group>
        </div>
    </ng-container>
</div>